import React, { useCallback, useRef } from "react";
import { registerToastAnchor } from "./toastAnchorRegistry";
import { Region } from "./ToastAnchor.styles";
import type { ToastAnchorProps } from "./ToastAnchor.types";

/** Wrap a region (a column of the page) with it; anchored toasts centre at its bottom while it is mounted. */
export const ToastAnchor: React.FC<ToastAnchorProps> = ({ id, children, className }) => {
  const cleanup = useRef<(() => void) | null>(null);
  const ref = useCallback(
    (element: HTMLDivElement | null) => {
      cleanup.current?.();
      cleanup.current = element ? registerToastAnchor(id, element) : null;
    },
    [id],
  );
  return (
    <Region ref={ref} className={className} data-toast-anchor={id}>
      {children}
    </Region>
  );
};

export default ToastAnchor;
